import styled from 'styled-components'

import { updatedMedia } from 'client/styles'

export const PaxesBase = styled.div`
  font-size: 16px;
  font-weight: 700;
  text-transform: lowercase;
  font-family: ${props => props.theme.fonts.families.primary};
  color: var(--color--neutral--600);

  &.withContent {
    color: var(--color--neutral--700);
  }

  &.full,
  &.borderless {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &.readonly {
    font-size: 14px;
    font-weight: 500;
    ${updatedMedia.onlyMobile} {
      display: inline;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  &.borderless {
    display: table-cell;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`
